module.exports = __webpack_public_path__ + "static/nxrt-rail2-25eac0950131e7de976f119993ca9b01.jpg";